<p-toast [style]="{ marginTop: '80px' }"></p-toast>
<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>

<p-table
  #pt
  [value]="msgs"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  dataKey="msgId"
  selectionMode="single"
  [(selection)]="msg"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"
  [paginator]="showPagination"
  [rows]="25"
  [rowsPerPageOptions]="[25, 100, 200]"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal"
  sortMode="multiple"
  [multiSortMeta]="multiSortMeta"
  styleClass="p-datatable-striped"
  [ngStyle]="{ width: 'auto' }"
  [resizableColumns]="true"
  [autoLayout]="true"
  [responsive]="true"
  >
  @if (!msgCampaignId || !reservationId) {
    <ng-template pTemplate="caption">
      <div class="d-block text-end justify-content-between align-items-center">
        @if (!msgCampaignId) {
          <h1 style="float: left; margin: 6px">Messages</h1>
        }
        @if (msgCampaignId) {
          <h5 style="float: left; margin: 6px">Messages</h5>
        }
        <span>
          <!--clear filters-->
          <button
            pButton
            pRipple
            class="p-button-text"
          style="
                    font-size: 80%;
                    padding: 0.643rem 0.75rem !important;
                    margin-right: 10px;
                  "
            (click)="loadLazy(lazyLoadEvent)"
            >
            Refresh
          </button>
          @if (showFilter) {
            <button
              pButton
              pRipple
              class="p-button-text"
          style="
            font-size: 80%;
            padding: 0.643rem 0.75rem !important;
            margin-right: 10px;
          "
              (click)="reloadPage()"
              >
              Clear Filters
            </button>
          }
          <!--add new-->
          @if (!outlineNewButton) {
            <button
              pButton
              pRipple
              class="p-button-outlined"
              style="padding: 0.643rem 0.75rem !important"
              (click)="onOpenFormAdd()"
              >
              New Msg +
            </button>
          }
          @if (false) {
            <span>
              <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important; margin-right: 10px;" (click)="sendFullMail()">
                Send Custom Mail
              </button>
              <!-- Jit 23-07-2024
              see conversation is absolute feature as user can always search with sender email address and receipient email address-->
              @if (false) {
                <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important; margin-right: 10px;" (click)="seeConversation()">
                  See Conversation
                </button>
              }
            </span>
          }
          @if (!msgCampaignId) {
            <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important" (click)="onOpenFormAdd()">
              New Msg +
            </button>
          }
          <p-dropdown
            [options]="msgOriginOptions"
            [(ngModel)]="selectedMsgOrigin"
            optionLabel="label"
            optionValue="value"
            placeholder="Origin: All"
            [showClear]="true"
            appendTo="body"
            (onChange)="onOriginFilterChange($event.value)"
            (onClear)="onOriginFilterChange(null)"
            style="margin-left: 10px; vertical-align: middle;"
          ></p-dropdown>
        </span>
      </div>
    </ng-template>
  }
  <ng-template pTemplate="header">
    @if (!isCompactList) {
      <tr >
        @for (col of columns; track col) {
          <th
            [pSortableColumn]="col.field"
            [ngStyle]="{ width: auto }">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{ width: 'auto' }"></th>
      </tr>
    }

    @if (isCompactList) {
      <tr >
        @for (col of columnsWithCompactList; track col) {
          <th
            [pSortableColumn]="col.field"
            [ngStyle]="{ width: col.width }">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{ width: 'auto' }"></th>
      </tr>
    }
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'msgId', 'in')" class="idFilter"></th>
        <th><p-dropdown #aa [options]="statusesForFilter" appendTo="body"
          (onChange)="pt.filter($event.value, 'status', 'in')" [style]="{'width':'50px','min-width':'100%'}"
          styleClass="p-column-filter" placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th><p-dropdown #aa [options]="msgEvents" appendTo="body"
        (onChange)="loadLazy(lazyLoadEvent)" [style]="{'width':'50px','min-width':'100%'}"
        styleClass="p-column-filter" placeholder="Filter" [(ngModel)]="selectedMsgEvent"  [showClear]="true" optionLabel="name" optionValue="name">
        <ng-template let-option pTemplate="item">
          <span>{{option.name}}</span>
        </ng-template>
      </p-dropdown>
    </th>
    <th [ngStyle]="{'width': 'auto'}"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'msgRecipientVOList.firstName', 'in')" style="width:100px;"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'msgRecipientVOList.email', 'in')" style="width:100px;"></th>
    @if (!isCompactList) {
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'msgRecipientVOList.mobileNum', 'in')" style="width:100px;"></th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'subject', 'in')" style="width:100px;"></th>
    @if (!isCompactList) {
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderName', 'in')" style="width:100px;"></th>
    }
    @if (!isCompactList) {
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderEmail', 'in')" style="width:100px;"></th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
    @if (!isCompactList) {
      <th [ngStyle]="{'width': 'auto'}">
        <p-multiSelect class="multiselectdropdown" [options]="msgTopics" displaySelectedLabel
          optionLabel="name" optionValue="value" appendTo="body" (onChange)="pt.filter($event.value, 'topic', 'in');" optionLabel="name"
          display="chip"
        [displaySelectedLabel]="true"></p-multiSelect>
      </th>
    }
    @if (!isCompactList) {
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'topicId', 'in')" style="width:50px;"></th>
    }
    @if (!isCompactList) {
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'topicPurpose', 'in')" style="width:50px;"></th>
    }
  </tr>
}
</ng-template>
<ng-template pTemplate="body" let-msg>
  <tr [pSelectableRow]="msg">
    <td>{{ msg.msgId }}</td>
    <td>{{ getStatusName(msg) }}</td>
    <td>
      @if (msg.msgRecipientAPIList[0]?.deliveredDate) {
        <span><i class="pi pi-check" aria-hidden="true" title='Delivered'></i></span>
      }
      @if (msg.msgRecipientAPIList[0]?.droppedDate) {
        <span><i class="pi pi-times" aria-hidden="true" title='dropped'></i></span>
      }
      @if (msg.msgRecipientAPIList[0]?.deferredDate) {
        <span><i class="pi pi-wave-pulse" aria-hidden="true" title='deferred'></i></span>
      }
      @if (msg.msgRecipientAPIList[0]?.bouncedDate) {
        <span><i class="pi pi-angle-down" aria-hidden="true" title='bounced'></i></span>
      }
      @if (msg.msgRecipientAPIList[0]?.openedDate) {
        <span><i class="pi pi-folder-open" aria-hidden="true" title='opened'></i></span>
      }
      @if (msg.msgRecipientAPIList[0]?.clickedDate) {
        <span><i class="pi pi-pencil" aria-hidden="true" title='clicked'></i></span>
      }
      @if (msg.msgRecipientAPIList[0]?.unsubscribedDate) {
        <span><i class="pi pi-sign-out" aria-hidden="true" title='unsubscribed'></i></span>
      }
    </td>
    <td><span class="origin-label origin-{{msg.msgOrigin}}">{{ originLabel(msg.msgOrigin) }}</span></td>
    <td>@if (msg && msg.msgRecipientAPIList && msg.msgRecipientAPIList[0]) {
      <span>{{ msg.msgRecipientAPIList[0].firstName }} {{msg.msgRecipientAPIList[0].lastName}}</span>
    }</td>
    <td>@if (msg && msg.msgRecipientAPIList && msg.msgRecipientAPIList[0]) {
      <span>{{ msg.msgRecipientAPIList[0].email }}</span>
    }</td>
    @if (!isCompactList) {
      <td>@if (msg.msgOrigin === 2 && msg.msgRecipientVOList && msg.msgRecipientVOList[0]) {
        <span>{{ msg.msgRecipientVOList[0].mobileNum }}</span>
      }</td>
    }
    <td>{{ msg.receivedDate|date:'medium' }}</td>
    <td style="white-space: inherit;">{{ msg.subject }}</td>
    @if (!isCompactList) {
      <td >{{ msg.senderName }}</td>
    }
    @if (!isCompactList) {
      <td >{{ msg.senderEmail }}</td>
    }
    <td>{{ msg.sentDate|date:'medium'  }}</td>
    @if (!isCompactList) {
      <td style="white-space: inherit;">{{ getTopicName(msg) }}</td>
    }
    @if (!isCompactList) {
      <td >{{ msg?.topicId }}</td>
    }
    @if (!isCompactList) {
      <td >{{ msg?.topicPurpose }}</td>
    }
    <td>
      <span style="float: none">
        <a>
          <i
            class="pi pi-pencil"
            aria-hidden="true"
            style="color: blue; font-size: 110%; padding-right: 20px"
            (click)="onOpenFormEdit(msg)"
          ></i>
          <i
            class="pi pi-trash"
            aria-hidden="true"
            style="color: red; font-size: 110%; padding-right: 20px"
            (click)="formDelete(msg)"
          ></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
